import makeStyles from '@material-ui/core/styles/makeStyles';

import { colors } from '../../assets/theme/palette';

export const useStyles = makeStyles({
  tile: {
    minHeight: 112,
    display: 'flex',
    background: colors.basic.white,
    border: `1px solid ${colors.grey20}`,
    transition: 'border-color 200ms ease 0s, box-shadow 200ms ease 0s ',

    '&.selected': {
      borderColor: colors.primary.main,
      boxShadow: `0px 0px 8px ${colors.primary.main}3d`,
    },

    '&.disabled': {
      opacity: 0.5,
      pointerEvents: 'none',
    },
  },
  tileRoot: {
    width: '100%',
    padding: '3px',
    lineHeight: 1.2,
  },
  iconContainer: {
    '& svg': {
      fontSize: '48px',
    },
  },
  iconText: {
    lineHeight: 'inherit',
  },
});
